import { Link } from 'react-router-dom'
import { HomeIcon } from '@heroicons/react/24/outline'

export const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="mt-4 text-3xl font-bold text-gray-900">Page not found</h2>
        <p className="mt-2 text-lg text-gray-500">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <div className="mt-8">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2 btn-primary"
          >
            <HomeIcon className="w-5 h-5" />
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  )
}
